var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"d-block d-sm-none",attrs:{"fluid":"xs"}},[_vm._t("default")],2),_vm._v(" "),_c('b-container',{staticClass:"d-none d-sm-block"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }